// One small tooltip at the pointer for the sidebar entries: an element's `data-tip`,
// or the value under the pointer on a profile.
import { parseLrChain } from "./lrValues.mjs";
import { buildProfile, profileValueAt } from "./positions.mjs";

const round = (v) => (typeof v === "number" ? Math.round(v * 100) / 100 : v);

function profileTip(plot, clientX) {
  const sections = parseLrChain(plot.dataset.chain);
  if (!sections) return null;
  const length =
    plot.dataset.length === "" ? null : Number(plot.dataset.length);
  const profile = buildProfile(sections, length);
  const rect = plot.getBoundingClientRect();
  const fraction = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
  const cm = Math.round(fraction * profile.axisEndCm);
  const at = profileValueAt(profile, cm);
  if (!at) return `${cm} cm: before the first point`;
  const range =
    at.startCm === at.endCm
      ? `at ${at.startCm}`
      : `${at.interpolated ? "between " : ""}${at.startCm}–${at.endCm}`;
  return `${round(at.value)} · ${range} · ${cm} cm`;
}

// One tooltip element for every row and the drawer.
let sharedTip = null;
function tipElement() {
  if (!sharedTip) {
    sharedTip = document.createElement("div");
    sharedTip.className = "fe-tip";
    sharedTip.style.display = "none";
    document.body.appendChild(sharedTip);
  }
  return sharedTip;
}

export function installPointerTip(root) {
  if (root.dataset.feTip) return;
  root.dataset.feTip = "1";
  const tip = tipElement();

  root.addEventListener("mousemove", (event) => {
    if (event.buttons) {
      // Drag-selecting text: no tooltip over what is being selected.
      tip.style.display = "none";
      return;
    }
    const target = event.target instanceof Element ? event.target : null;
    const band = target && target.closest("[data-tip]");
    const plot = !band && target && target.closest(".fe-profile");
    const text = band
      ? band.dataset.tip
      : plot
        ? profileTip(plot, event.clientX)
        : null;
    if (!text) {
      tip.style.display = "none";
      return;
    }
    tip.textContent = text;
    tip.style.display = "block";
    tip.style.left = `${event.clientX + 12}px`;
    tip.style.top = `${event.clientY + 14}px`;
  });
  root.addEventListener("mouseleave", () => {
    tip.style.display = "none";
  });
}
